/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCreateInvestigationNote
 */
export interface InternalApiCreateInvestigationNote {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateInvestigationNote
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCreateInvestigationNote
     */
    draftId?: number;
}

/**
 * Check if a given object implements the InternalApiCreateInvestigationNote interface.
 */
export function instanceOfInternalApiCreateInvestigationNote(value: object): value is InternalApiCreateInvestigationNote {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCreateInvestigationNoteFromJSON(json: any): InternalApiCreateInvestigationNote {
    return InternalApiCreateInvestigationNoteFromJSONTyped(json, false);
}

export function InternalApiCreateInvestigationNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateInvestigationNote {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'draftId': json['draftId'] == null ? undefined : json['draftId'],
    };
}

export function InternalApiCreateInvestigationNoteToJSON(json: any): InternalApiCreateInvestigationNote {
    return InternalApiCreateInvestigationNoteToJSONTyped(json, false);
}

export function InternalApiCreateInvestigationNoteToJSONTyped(value?: InternalApiCreateInvestigationNote | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'draftId': value['draftId'],
    };
}

